import { render } from "./StudyQuestions.vue?vue&type=template&id=29bc0e02"
import script from "./StudyQuestions.vue?vue&type=script&lang=js"
export * from "./StudyQuestions.vue?vue&type=script&lang=js"

import "./StudyQuestions.vue?vue&type=style&index=0&id=29bc0e02&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__